import TrainerInfoPrivateTraining from './TrainerInfoPrivateTraining';
import TrainerInfoCoaching from './TrainerInfoCoaching';
import TrainerInfoLanguages from './TrainerInfoLanguages';
import {
  trainerInfoDefaultProps,
  trainerInfoPropTypes,
} from './TrainerInfoShape';

const defaultProps = {
  ...trainerInfoDefaultProps,
};

const propTypes = {
  ...trainerInfoPropTypes,
};

export default function TrainerInfo({ privateTraining, coaching, languages }) {
  const hasPrivateTraining = privateTraining !== null;
  const hasCoaching = coaching !== null;
  const hasLanguages = languages !== null && languages.length !== 0;

  return (
    <div className="space-y-2 pt-4">
      {hasPrivateTraining && (
        <TrainerInfoPrivateTraining value={privateTraining} />
      )}
      {hasCoaching && <TrainerInfoCoaching value={coaching} />}
      {hasLanguages && <TrainerInfoLanguages languages={languages} />}
    </div>
  );
}

TrainerInfo.defaultProps = defaultProps;
TrainerInfo.propTypes = propTypes;
